import { useEffect, useState } from "react";
import { Quote } from "lucide-react";
import { api } from "../lib/api";

export const useReviews = () => {
  const [reviews, setReviews] = useState(null);
  useEffect(() => { api.get("/reviews").then((r) => setReviews(r.data)).catch(() => setReviews([])); }, []);
  return reviews;
};

export const Testimonials = ({ reviews }) => (
  <div className="grid gap-px bg-slate-200 border border-slate-200 md:grid-cols-2 lg:grid-cols-3" data-testid="testimonials-grid">
    {reviews.map((t, i) => (
      <figure key={t.id} className="bg-white p-7 flex flex-col hover:bg-[#F7F8FA] transition-colors" data-testid={`testimonial-${i}`}>
        <Quote className="w-7 h-7 text-orange-600" />
        <blockquote className="mt-5 text-slate-800 leading-relaxed flex-1">"{t.text}"</blockquote>
        <figcaption className="mt-6 pt-5 border-t border-slate-200">
          <div className="flex items-center justify-between gap-3">
            <div>
              <div className="font-display font-bold uppercase tracking-wide text-slate-900">{t.name}</div>
              <div className="text-xs text-slate-500">{t.location}</div>
            </div>
            {t.route && <div className="font-mono text-[10px] uppercase tracking-wider text-brand-600 text-right">{t.route}</div>}
          </div>
          {t.vehicle && <div className="mt-2 text-[11px] text-slate-500">{t.vehicle}</div>}
        </figcaption>
      </figure>
    ))}
  </div>
);
